// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invItemId } from './InvItem';
import { z } from 'zod';
export const inventoryItemBackorderId = (z.number());
export const inventoryItemBackorder = z.object({
    id: inventoryItemBackorderId,
    backorder_quantity: z.number().nullable(),
    inventory_item_id: invItemId.nullable(),
});
export const inventoryItemBackorderInitializer = z.object({
    id: inventoryItemBackorderId.optional(),
    backorder_quantity: z.number().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
});
export const inventoryItemBackorderMutator = z.object({
    id: inventoryItemBackorderId.optional(),
    backorder_quantity: z.number().optional().nullable(),
    inventory_item_id: invItemId.optional().nullable(),
});
//# sourceMappingURL=InventoryItemBackorder.js.map